import { QuickAdd } from '@ui/general';
import { takeRandom } from '@sonar-software/sonar-ts-lib';

import { COPY_SONAR_OBJECT_BASE, TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import React, { useEffect, useRef } from 'react';
import { useCreateTag, useCurrentUser } from '@hooks';

export interface CreateTagProps {
	onFinish?: (tagId: number) => void;
}

export const CreateTag: React.FC<CreateTagProps> = ({ onFinish }) => {
	const { isProcessing, isSuccessful, request, reset, result } = useCreateTag();
	const { id } = useCurrentUser();

	const onFinishRef = useRef(onFinish);
	onFinishRef.current = onFinish;

	useEffect(() => {
		if (isSuccessful && result) {
			onFinishRef.current?.(result.sonarObjectTagId);
			reset();
		}
	}, [ isSuccessful, reset, result ]);

	return (
		<QuickAdd
			onSubmit={ (value) =>
				request({
					description: '',
					hexColor: takeRandom(TAG_COLORS),
					name: value?.trim(),
					ownerIds: [ id ]
				}) }
			processing={ isProcessing }
			typeLabel={ COPY_SONAR_OBJECT_BASE.TAG } />
	);
};
